<div class="container border border-success rounded mt-2">
  <form [formGroup]="SimuladorForm" novalidate>
    <div class="container">
      <div class="card border border-success rounded mt-3">
        <h5 class="card-header">
          <!-- Simulaci&oacute;n -->
          Carrera Seleccionada
          <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#Simulacion" role="button"
             aria-expanded="true" aria-controls="Simulacion">
          </a>
        </h5>
        <div class="collapse show" id="Simulacion">
          <div class="card-body">
            <div class="alert alert-info" role="alert">
              A continuación, podrás ver tu carrera y sede seleccionada para estudiar en la Universidad
              Santo Tomás.
            </div>
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>
                      Institución
                      <app-spinner [visible]="result_institucion.loading"></app-spinner>
                    </label>
                    <select class="form-control form-control-sm" formControlName="Institucion"
                            (change)="ChangeInstitucion($event)">
                      <option value="" selected>Seleccionar</option>
                      <option *ngFor="let inst of result_institucion.data" value="{{ inst.Id }}">
                        {{ inst.Nombre2 }}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !SimuladorForm.controls['Institucion'].valid &&
                        SimuladorForm.controls['Institucion']?.touched
                      ">Por favor, Seleccionar una institución válida</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>
                      Sede
                      <app-spinner [visible]="result_sede.loading"></app-spinner>
                    </label>
                    <select class="form-control form-control-sm" formControlName="Sede"
                            (change)="ChangeSede($event)">
                      <option value="">Seleccione</option>
                      <option value="d16b6206-5511-eb11-80cf-005056bbdae9"> IPST Valdivia</option>
                      <option *ngFor="let sede of result_sede.data" value="{{ sede.Id }}">
                        {{ sede.Nombre }}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !SimuladorForm.controls['Sede'].valid &&
                        SimuladorForm.controls['Sede']?.touched
                      ">Por favor, Seleccionar una sede válida</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>Direcci&oacute;n de sede</label>
                    <input type="text" class="form-control form-control-sm"
                           formControlName="Direccion"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="row container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>
                      Área de estudio
                      <app-spinner [visible]="result_areaDeEstudio.loading"></app-spinner>
                    </label>
                    <select class="form-control form-control-sm" formControlName="Area"
                            (change)="ChangeArea($event)">
                      <option value="">Seleccione</option>
                      <option *ngFor="let area of result_areaDeEstudio.data"
                              value="{{ area.Id }}">
                        {{ area.Nombre }}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !SimuladorForm.controls['Area'].valid &&
                        SimuladorForm.controls['Area']?.touched
                      ">Por favor, Seleccionar una area válida</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>
                      Jornada
                      <app-spinner [visible]="result_jornada.loading"></app-spinner>
                    </label>
                    <select class="form-control form-control-sm" formControlName="Jornada"
                            (change)="ChangeJornada($event)">
                      <option value="">Seleccione</option>
                      <option *ngFor="let jornada of result_jornada.data"
                              value="{{ jornada.Id }}">
                        {{ jornada.Nombre }}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !SimuladorForm.controls['Jornada'].valid &&
                        SimuladorForm.controls['Jornada']?.touched
                      ">Por favor, Seleccionar una jornada válida</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>
                      Tipo de programa
                    </label>
                    <select class="form-control form-control-sm" formControlName="TipoPrograma"
                            (change)="ChangeJornada($event)">
                      <option value="">Seleccione</option>
                      <option value="1">Regular</option>
                      <option value="2">Continuidad</option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !SimuladorForm.controls['TipoPrograma'].valid &&
                        SimuladorForm.controls['TipoPrograma']?.touched
                      ">Por favor, Seleccionar un tipo de programa válido</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>
                      Carrera
                      <app-spinner [visible]="result_carrera.loading"></app-spinner>
                    </label>
                    <select class="form-control form-control-sm" formControlName="Carrera"
                            id="selectCarrera" (change)="ChangeCarrera($event)">
                      <option value="">Seleccione</option>
                      <option value="c1847681-5e11-eb11-80cf-005056bbdae9">Técnico En Diseño De
                        Videojuegos
                      </option>
                      <option *ngFor="let carrera of result_carrera.data"
                              value="{{ carrera.Id }}">
                        {{ carrera.Nombre }}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !SimuladorForm.controls['Carrera'].valid &&
                        SimuladorForm.controls['Carrera']?.touched
                      ">Por favor, Seleccionar una carrera válida</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>Modalidad
                      <app-spinner [visible]="result_modalidad.loading"></app-spinner>
                    </label>
                    <input type="text" class="form-control form-control-sm"
                           formControlName="Modalidad"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="row container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>Tipo de Plan
                      <app-spinner [visible]="result_modalidad.loading"></app-spinner>
                    </label>
                    <input type="text" class="form-control form-control-sm"
                           formControlName="TipoPlan"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="row container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>Vía Admisión</label>
                    <input type="text" class="form-control form-control-sm"
                           formControlName="ViaAdmision"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2 container" *ngIf="showBtnSimular">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <label>&nbsp;</label>
                    <app-apibutton text="Obtener Arancel de Carrera" [progress]="progress"
                                   (click)="Simular()"></app-apibutton>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="alert alert-danger" role="alert" *ngIf="errorViaIngreso">
        De acuerdo a tus antecedentes educacionales, el Sistema de Matrícula Online no puede asignarte una vía
        de ingreso, te sugerimos tomar contacto con la Sede donde deseas estudiar para que evalúes otra vía de
        ingreso a esta carrera
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="errorAlSimular && !errorViaIngreso">
        Intenta nuevamente presionando el botón "Obtener Arancel de Carrera"
      </div>

      <div class="card border border-success" id="divCopago" *ngIf="
          result_copagoMatriculayArancel.loading ||
          result_copagoMatriculayArancel.loaded
        ">
        <h5 class="card-header">
          Matrícula y Aranceles
          <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#CopagosGroup" role="button"
             aria-expanded="true" aria-controls="CopagosGroup">
          </a>
        </h5>
        <div class="collapse show p-20" id="CopagosGroup">
          <div class="alert alert-info" role="alert">
            A continuación, podrás conocer el arancel y valor de matrícula de la carrera, sede y jornada
            seleccionada, sumado a los descuentos y/o beneficios internos o del Mineduc asociados a tus
            antecedentes, los cuales serán entregados en forma automática por
            el sistema.
          </div>

          <app-progress *ngIf="result_copagoMatriculayArancel.loading"></app-progress>
          <div class="alert alert-danger" role="alert" *ngIf="
              result_copagoMatriculayArancel.loaded &&
              !result_copagoMatriculayArancel.success
            ">
            Ocurri&oacute; un error al cargar <strong>Matr&iacute;cula</strong>
          </div>
          <div class="card border border-success" *ngIf="
              result_copagoMatriculayArancel.loaded &&
              result_copagoMatriculayArancel.success
            ">
            <h5 class="card-header">
              Matr&iacute;cula
              <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#CopagoMatricula"
                 role="button" aria-expanded="true" aria-controls="CopagoMatricula">
              </a>
            </h5>
            <div class="collapse show" id="CopagoMatricula">
              <div class="card-body">
                <table class="table table-sm" *ngIf="
                    result_copagoMatriculayArancel.success &&
                    !result_copagoMatriculayArancel.loading
                  ">
                  <thead>
                  <tr>
                    <th scope="col">Primer Semestre</th>
                    <th scope="col">Segundo Semestre</th>
                    <th scope="col">Matrícula Anual</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .ValorSemestreMatriculaLista | numerico }}
                    </th>
                    <td>
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .ValorSemestreDosMatriculaLista | numerico }}
                    </td>
                    <td>
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .ValorAnualMatriculaListaOriginal | numerico }}
                    </td>
                  </tr>
                  </tbody>

                  <tbody *ngIf="result_dcto.loading">
                  <tr>
                    <td colspan="3">
                      <app-progress></app-progress>
                    </td>
                  </tr>
                  </tbody>

                  <tbody *ngIf="result_dcto.loading">
                  <tr>
                    <td colspan="3">
                      <div class="alert alert-warning" role="alert" *ngIf="
                            result_copagoMatriculayArancel.loaded &&
                            result_dcto.loaded &&
                            !(
                              result_dcto.data.RetornoDesdeApi &&
                              result_dcto.data.RetornoDesdeApi.length > 0
                            )
                          ">
                        No tiene descuento
                      </div>
                    </td>
                  </tr>
                  </tbody>

                  <thead *ngIf="
                      result_copagoMatriculayArancel.loaded &&
                      result_copagoMatriculayArancel.success &&
                      result_dcto.loaded &&
                      result_dcto.success &&
                      result_dcto.data.RetornoDesdeApi &&
                      result_dcto.data.RetornoDesdeApi.length > 0
                    ">
                  <tr>
                    <th scope="col">Beca Matrícula</th>
                    <th scope="col">Valor Beca</th>
                    <th scope="col">Matrícula a Pagar</th>
                  </tr>
                  </thead>
                  <tbody *ngIf="
                      result_copagoMatriculayArancel.loaded &&
                      result_copagoMatriculayArancel.success &&
                      result_dcto.loaded &&
                      result_dcto.success &&
                      result_dcto.data.RetornoDesdeApi &&
                      result_dcto.data.RetornoDesdeApi.length > 0
                    ">
                  <tr>
                    <th scope="row">
                      {{ result_dcto.data.RetornoDesdeApi[0].DATA[0].porcentajeDescuento /
                    100 | percent: "2.2-2" }}
                    </th>
                    <td style="color: red;">
                      {{ -result_dcto.ValorDcto | numerico }}
                    </td>
                    <td>
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .ValorAnualMatriculaLista | numerico }}
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="alert alert-info" role="alert" *ngIf="result_dcto && result_dcto.mensaje">
                  {{ result_dcto.mensaje }}
                </div>
              </div>
            </div>
          </div>
          <div class="alert alert-danger" role="alert" *ngIf="
              result_copagoMatriculayArancel.loaded &&
              !result_copagoMatriculayArancel.success
            ">
            Ocurrió un error al cargar <strong>Colegiatura</strong>
          </div>
          <div class="card border border-success" *ngIf="
              result_copagoMatriculayArancel.loaded &&
              result_copagoMatriculayArancel.success &&
              result_dcto.loaded &&
              result_dcto.success
            ">
            <h5 class="card-header">
              Colegiatura
              <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#CopagoArancel"
                 role="button" aria-expanded="true" aria-controls="CopagoArancel">
              </a>
            </h5>

            <div class="collapse show" id="CopagoArancel">
              <div class="card-body">
                <table class="table table-sm" *ngIf="result_copagoMatriculayArancel.success">
                  <thead>
                  <tr>
                    <th scope="col">Primer Semestre</th>
                    <th scope="col">Segundo Semestre</th>
                    <th scope="col">Colegiatura Anual</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .ValorSemestreArancelLista | numerico }}
                    </th>
                    <td>
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .ValorSemestreDosArancelLista | numerico }}
                    </td>
                    <td>
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .ValorAnualArancelLista | numerico }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border border-success" id="divBecas" *ngIf="
              result_becaMineduc.tieneDatosValidos ||
              result_becaPSU.tieneDatosValidos ||
              result_becaCAE.tieneDatosValidos
            ">
        <h5 class="card-header">
          Becas, Descuentos o Beneficios
          <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#BecasGroup" role="button"
             aria-expanded="true" aria-controls="BecasGroup">
          </a>
        </h5>
        <div class="collapse show p-20" id="BecasGroup">
          <app-progress *ngIf="result_becaMineduc.loading"></app-progress>
          <div class="alert alert-danger" role="alert"
               *ngIf="result_becaMineduc.loaded && !result_becaMineduc.success">
            Ocurrió un error al cargar <strong>Beca Mineduc</strong>
          </div>
          <div id="divBecaMineduc" class="card border border-success" *ngIf="
              result_becaMineduc.loaded &&
              result_becaMineduc.success &&
              result_becaMineduc.tieneDatosValidos
            ">
            <h5 class="card-header">
              Beca Mineduc
              <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#Mineduc"
                 role="button" aria-expanded="true" aria-controls="Mineduc"></a>
            </h5>
            <div class="collapse show" id="Mineduc">
              <div class="alert alert-info" role="alert">
                En el caso de contar con alguna beca o beneficio del Mineduc, esta se reflejará a
                continuación.
              </div>
              <div class="card-body">
                <div class="alert alert-warning" role="alert"
                     *ngIf="!result_becaMineduc.tieneDatosValidos">
                  No tiene <strong>Beca Mineduc</strong>
                </div>
                <table class="table table-sm" *ngIf="result_becaMineduc.tieneDatosValidos">
                  <thead>
                  <tr>
                    <th scope="col">Monto Beca Mineduc</th>
                    <th scope="col">Valor Descuento BECA</th>
                    <th scope="col">Colegiatura a Pagar</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">
                      {{ result_becaMineduc.data.ListBecaMineduc[0].Monto | numerico }}
                    </th>
                    <td style="color: red;">
                      {{ -result_becaMineduc.data.ListBecaMineduc[0].Monto | numerico }}
                    </td>
                    <td>
                      {{ result_becaMineduc.totalAcumulado | numerico }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <app-progress *ngIf="result_becaPSU.loading"></app-progress>
          <div class="alert alert-danger" role="alert"
               *ngIf="result_becaPSU.loaded && !result_becaPSU.success">
            Ocurrió un error al cargar <strong>Beca PAES</strong>
          </div>
          <div class="card border border-success" *ngIf="
              result_becaPSU.loaded &&
              result_becaPSU.success &&
              result_becaPSU.tieneDatosValidos
            ">
            <h5 class="card-header">
              Beca PAES
              <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#PSU" role="button"
                 aria-expanded="true" aria-controls="PSU"></a>
            </h5>
            <div class="collapse show" id="PSU">
              <div class="alert alert-info" role="alert">
                Universidad Santo Tomás premia con un descuento en el arancel a quienes cuenten con un
                puntaje PAES/PDT destacado, y este se reflejará a continuación en el caso de cumplir con los
                requisitos.
              </div>
              <div class="card-body">
                <div class="alert alert-warning" role="alert" *ngIf="!result_becaPSU.tieneDatosValidos">
                  No tiene <strong>Beca PAES</strong>
                </div>
                <table class="table table-sm" *ngIf="result_becaPSU.tieneDatosValidos">
                  <thead>
                  <tr>
                    <th scope="col">Beca PAES</th>
                    <th scope="col">Valor Descuento Beca</th>
                    <th scope="col">Colegiatura A Pagar</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">
                      {{ result_becaPSU.porcentaje / 100 | percent: "2.2-2" }}
                    </th>
                    <td style="color: red;">{{ -result_becaPSU.valorDcto | numerico }}</td>
                    <td>{{ result_becaPSU.totalAcumulado | numerico }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <app-progress *ngIf="result_becaCAE.loading"></app-progress>
          <div class="alert alert-danger" role="alert"
               *ngIf="result_becaCAE.loaded && !result_becaCAE.success">
            Ocurrió un error al cargar <strong>CAE</strong>
          </div>
          <div class="card border border-success" *ngIf="
              result_becaCAE.loaded &&
              result_becaCAE.success &&
              result_becaCAE.tieneDatosValidos
            ">
            <h5 class="card-header">
              CAE
              <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#CAE" role="button"
                 aria-expanded="true" aria-controls="CAE"></a>
            </h5>
            <div class="collapse show" id="CAE">
              <div class="alert alert-info" role="alert">
                En el caso de haber solicitado el Crédito con Garantía Estatal, se reflejará a
                continuación el porcentaje a utilizar y el monto total sin financiamiento que debes
                cancelar.
              </div>
              <div class="card-body">
                <table class="table table-sm">
                  <thead>
                  <tr>
                    <th scope="col">CAE Preaprobado</th>
                    <th scope="col">¿Desea usar el cr&eacute;dito?</th>
                    <th scope="col">Monto a utilizar</th>
                    <th scope="col">Coleg. a Doc.</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">
                      {{ result_becaCAE.MontoCAE | numerico }}
                    </th>
                    <td>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="UsarMontoCAE"
                               formControlName="UsarMontoCAE"
                               *ngIf="result_becaCAE.MontoCAE > 0"
                               (change)="changeUtilizarCae()"/>
                        <label class="form-check-label" for="UsarMontoCAE">
                        </label>
                      </div>
                    </td>
                    <td>
                      <input type="text" digitOnly class="form-control form-control-sm"
                             placeholder="0" formControlName="MontoAUtilizar" *ngIf="
                            result_becaCAE.MontoCAE > 0 &&
                            this.SimuladorForm.get('UsarMontoCAE').value == true
                          " (change)="changeMontoUtilizar()"/>
                    </td>
                    <td>{{ result_becaCAE.totalAcumulado | numerico }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border border-success" id="divPagos"
           *ngIf="result_pagoAlDia.loading || result_pagoAlDia.loaded">
        <h5 class="card-header">
          Pagos
          <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#PagosGroup" role="button"
             aria-expanded="true" aria-controls="PagosGroup">
          </a>
        </h5>

        <div class="collapse show p-20" id="PagosGroup">
          <div *ngIf="!MetodoFirma">
            <!--Ocultar el pago  d-none-->
            <div class="card border border-success"
                *ngIf="result_pagoAlDia.loaded && result_pagoAlDia.success">

              <h5 class="card-header">
                <!-- Pagar todo al contado -->
                <div class="form-check">
                  <br/>
                  <input class="form-check-input" type="checkbox" id="PagoAlContado"
                        formControlName="PagoAlContado" (change)="this.recalcular()"/>

                  <label class="form-check-label" for="PagoAlContado">
                    Pago al Contado - Paga Colegiatura al contado (webpay) para recibir descuento
                  </label>
                </div>
                <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#PagoContado"
                  role="button" aria-expanded="true" aria-controls="PagoContado"></a>
              </h5>
              <div class="collapse show" id="PagoContado">
                <div class="card-body">
                  <table class="table table-sm" *ngIf="result_pagoAlDia.success">
                    <thead>
                    <tr>
                      <th scope="col">Matr&iacute;cula A doc.</th>
                      <th scope="col">Descuento pago Contado</th>
                      <th scope="col">Total a Pagar Contado</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">
                        <!-- {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0].ValorAnualMatriculaLista | numerico }} -->
                        {{ result_pagoContado.MatriculaADoc | numerico }}
                      </th>
                      <td>
                        <!-- {{ result_dcto.ValorDcto | numerico }} -->
                        {{ result_pagoContado.MontoDcto | numerico }}
                      </td>
                      <td>
                        <!-- {{ result_dcto.totalAcumulado | numerico }} -->
                        {{ result_pagoContado.totalAcumulado | numerico }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <app-progress *ngIf="result_pagoAlDia.loading"></app-progress>
            <div class="alert alert-danger" role="alert" *ngIf="result_pagoAlDia.loaded && !result_pagoAlDia.success">
              Ocurrió un error al cargar <strong>Pago Al Día</strong>
            </div>
            <div class="card border border-success" *ngIf="
                  result_pagoAlDia.loaded &&
                  result_pagoAlDia.success &&
                  !pagoAlContado
                ">
              <h5 class="card-header">
                <!--Pago Al Día-->Pago Al Día
                <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#PagoDia" role="button"
                  aria-expanded="true" aria-controls="PagoDia"></a>
              </h5>
              <div class="collapse show" id="PagoDia">
                <div class="card-body">
                  <table class="table table-sm">

                    <thead>
                    <tr>
                      <th scope="col">Monto al d&iacute;a (ingresar)</th>
                      <th scope="col">Fecha del Documento</th>
                      <th scope="col">Abono Matr&iacute;cula</th>
                      <th scope="col">Abono Colegiatura</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">
                        <input type="text" digitOnly class="form-control form-control-sm"
                              placeholder="Ingresa el monto" formControlName="MontoAlDia"
                              (change)="this.recalcular()"/>
                      </th>
                      <td>
                        {{
                        result_pagoAlDia.FechaDocumento | date: "dd-MM-yyyy"
                        }}
                      </td>
                      <td>
                        {{ result_pagoAlDia.data.AbonoMatricula | numerico }}
                      </td>
                      <td>
                        {{ result_pagoAlDia.data.AbonoColegiatura | numerico }}
                      </td>
                    </tr>
                    </tbody>

                  </table>
                  <table class="table table-sm">
                    <thead>
                    <tr>
                      <th scope="col">&nbsp;</th>
                      <th scope="col">&nbsp;</th>
                      <th scope="col">Matrícula por Documentar</th>
                      <th scope="col">Colegiatura por Documentar</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">&nbsp;</th>
                      <td>&nbsp;</td>
                      <td>
                        {{ result_pagoAlDia.data.MatriculaDoc | numerico }}
                      </td>
                      <td>{{ result_pagoAlDia.data.ColegDoc | numerico }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="alert alert-info" role="alert" *ngIf="result_pagoAlDia.data.MatriculaDoc > 0">

                    La matrícula se pagará en {{
                    result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .cuotasAnualesMatriculas | number
                    }} cuota con fecha de primer vencimiento {{
                    result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .fechaTopeCopagoMatricula | date: "dd-MM-yyyy"
                    }}. El documento se generará
                    automáticamente y será enviado a tu correo {{userData?.CorreoElectronico}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card border border-success" *ngIf="
              result_pagoAlDia.loaded &&
              result_pagoAlDia.success &&
              !pagoAlContado
            ">
            <h5 class="card-header">
              <!--Pago Al Día-->Resumen
              <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#PagoDia"
                 role="button" aria-expanded="true" aria-controls="PagoDia"></a>
            </h5>
            <div class="collapse show" id="PagoDia">
              <div class="card-body">
                <table class="table table-sm">
                  <thead>
                  <tr>
                    <th scope="col">&nbsp;</th>
                    <th scope="col">&nbsp;</th>
                    <th scope="col">Matrícula por Documentar</th>
                    <th scope="col">Colegiatura por Documentar</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">&nbsp;</th>
                    <td>&nbsp;</td>
                    <td>
                      {{ result_pagoAlDia.data.MatriculaDoc | numerico }}
                    </td>
                    <td>{{ result_pagoAlDia.data.ColegDoc | numerico }}</td>
                  </tr>
                  </tbody>
                </table>
                <!--                <div class="alert alert-info" role="alert">-->
                <!--                  EL PAGO DE MATRÍCULA, EN EL CASO QUE CORRESPONDA PAGO, SE REALIZARÁ EN 1 CUOTA, CON FECHA DE-->
                <!--                  VENCIMIENTO 31-01-2021.-->
                <!--                </div>-->
              </div>
            </div>
          </div>

          <app-progress *ngIf="result_pagoColegiaturaPlazo.loading"></app-progress>
          <div class="alert alert-danger" role="alert" *ngIf="
              result_pagoColegiaturaPlazo.loaded &&
              !result_pagoColegiaturaPlazo.success
            ">
            Ocurrió un error al cargar
            <strong>PAGO EN CUOTAS COLEGIATURA</strong>
          </div>
          <div class="card border border-success" *ngIf="
              result_pagoColegiaturaPlazo.loaded &&
              result_pagoColegiaturaPlazo.success &&
              !pagoAlContado
            ">
            <h5 class="card-header">
              Pago de Colegiatura a Plazo
              <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#Colegiatura"
                 role="button" aria-expanded="true" aria-controls="Colegiatura"></a>
            </h5>
            <div class="collapse show" id="Colegiatura">
              <div class="card-body">
                <table class="table table-sm" *ngIf="result_pagoColegiaturaPlazo.success">
                  <thead>
                  <tr>
                    <th scope="col">Semestre</th>
                    <th scope="col">Tipo de pago</th>
                    <th scope="col">Total</th>
                    <th scope="col">Cuotas</th>
                    <th scope="col">Fecha 1er pago</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Cuota</td>
                    <td>
                      {{ result_pagoColegiaturaPlazo.data.MontoSemestre1 | numerico }}
                    </td>
                    <td>
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .cuotasCopagoArancelSemestre1 | numerico }}
                    </td>
                    <td>
                      <!--<select class="form-control form-control-sm"
                              style="width: 60px; display: inline" formControlName="DiasPagoSem1"
                              (change)="fechaPagoChange(1)">
                        <option *ngFor="
                              let day of result_copagoMatriculayArancel.diasPagoSem1
                            " value="{{ day }}">
                          {{ day }}
                        </option>
                      </select> -->
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .FechaVctoCopagoArancelSemestre | date: "dd-MM-yyyy" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Cuota</td>
                    <td>
                      {{ result_pagoColegiaturaPlazo.data.MontoSemestre2 | numerico }}
                    </td>
                    <td>
                      {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .cuotasCopagoArancelSemestre2 | numerico }}
                    </td>
                    <td>
                      <!--<select class="form-control form-control-sm"
                              style="width: 60px; display: inline" formControlName="DiasPagoSem2"
                              (change)="fechaPagoChange(2)">
                        <option *ngFor="
                              let day of result_copagoMatriculayArancel.diasPagoSem2
                            " value="{{ day }}">
                          {{ day }}
                        </option>
                      </select>-->
                       {{ result_copagoMatriculayArancel.data.RetornoDesdeApi[0]
                      .FechaVctoCopagoArancelSegundoSemestre | date: "dd-MM-yyyy" }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="divBottom"></div>

      <div class="row mb-2 mt-2" *ngIf="
          todoCargado &&
          (faseActual === '3' || (faseActual === '4' && changeCarreraCount > 0))
        " id="divBotones">
        <div class="col-md-3">&nbsp;</div>
        <div class="col-md-3 mr-2">
          &nbsp;
        </div>
        <div class="col-md-3 ml-2">
          <app-apibutton text="Guardar y continuar" [progress]="enviando" (click)="guardar(true)">
          </app-apibutton>
        </div>
        <div class="col-md-3">&nbsp;</div>
      </div>
    </div>
  </form>
</div>

<!-- Modal Bloqueo Financiero -->
<div class="modal fade" id="bloqueoFinancieroModal" tabindex="-1" aria-labelledby="bloqueoFinancieroModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <p class="text-left">Estimado(a) Postulante:</p>
        <p class="text-left">
          De acuerdo a nuestros registros tienes una situación financiera que regularizar, sin embargo, podrás
          continuar con tu proceso de matrícula y completarla, posteriormente un ejecutivo de admisión tomará
          contacto para regularizar esta situación.
        </p>
        <p class="text-left">
          Atentamente, <br/> Dirección de Admisión, Santo Tomás.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Modal Bloqueo Financiero -->

<!-- Modal Bloqueo Académico -->
<div class="modal fade" id="bloqueoAcademicoModal" tabindex="-1" aria-labelledby="bloqueoAcademicoModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <p class="text-left text-danger font-weight-bold">
          Usted presenta una restricción para continuar con el proceso de matrícula del programa seleccionado,
          es por ello que se le presentan las siguientes opciones:
        </p>
        <div class="btn-toolbar text-center d-flex justify-content-around">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Bloqueo Académico -->

<!-- Modal Existe Matrícula -->
<div class="modal fade" id="modalExisteMatri" tabindex="-1" aria-labelledby="modalExisteMatri" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <p class="text-left">Estimado(a) estudiante,</p>
        <p class="text-left">
          Nuestros registros indican que usted ya posee una matrícula para el periodo seleccionado.
        </p>
        <p class="text-left">
          Si necesitas información de contacto de nuestras Sedes, podrás obtenerla en
          <a href="http://www.santotomas.cl/contactossedes.html"
             class="text-primary">http://www.santotomas.cl/contactossedes.html</a>
        </p>
        <p class="text-left">
          Atentamente, <br/> Dirección de Admisión, Santo Tomás.
        </p>
      </div>
    </div>
  </div>
</div>
